export default function SectionToggle(props) {
  const { enabledOn, children, disabledOn } = props;

  if (enabledOn || (disabledOn !== undefined && !disabledOn)) {
    return children;
  }

  return null;
}
